import React from "react";
import Http, * as Endpoint from "../Http";
import * as action from "../store/actions";
import {
  updateDebtorEmail,
  setDossierList,
  setDateOfBirth,
} from "../store/actions";
import { errorsTransformer } from "../Http";
import { bugsnagClient } from "./bugsnag";

/**
 * Fetch dossier
 *
 * @returns {function(*=): Promise<unknown>}
 */
export const getDossier = (onlyDossier = false) => {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get(Endpoint.FETCH_DOSSIER)
        .then(res => {
          dispatch(action.setDossier(res.data));
          dispatch(action.authDossierLogin(res.data));

          if (!onlyDossier) {
            dispatch(getInvoices()).catch(err => {
              bugsnagClient.leaveBreadcrumb("Dossier loaded without invoices");
            });
          }

          setTimeout(resolve, 500);
        })
        .catch(err => {
          reject(errorsTransformer(err));
        });
    });
};

/**
 * Fetch Dossier invoices
 *
 * @returns {function(*=): Promise<unknown>}
 */
export const getInvoices = () => {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get(Endpoint.FETCH_DOSSIER_INVOICES)
        .then(res => {
          dispatch(action.setInvoices(res.data));
          resolve();
        })
        .catch(err => {
          reject(errorsTransformer(err));
        });
    });
};

/**
 * Change the debtor's emailaddress
 *
 * @param payload
 */
export const sendEditEmailRequest = payload => {
  return dispatch =>
    new Promise((resolve, reject) =>
      Http.post(Endpoint.EDIT_EMAIL_ADDRESS, payload)
        .then(res => {
          dispatch(updateDebtorEmail(payload.get("email")));
          resolve();
        })
        .catch(err => {
          reject(errorsTransformer(err));
        })
    );
};

export const fetchDossiersList = birthDate => {
  return dispatch =>
    new Promise((resolve, reject) =>
      Http.get(`${Endpoint.FETCH_DOSSIER_LIST}?birth_date=${birthDate}`)
        .then(res => {
          dispatch(action.authDossierLogin(res.data));
          dispatch(setDateOfBirth(birthDate));
          dispatch(setDossierList(res.data.data));
          resolve(res.data.data);
        })
        .catch(err => {
          reject(errorsTransformer(err));
        })
    );
};

export const fetchDossiersListCriteria = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await Http.get(
        Endpoint.FETCH_PAYMENT_PLAN_REQUEST_MULTIPLE_DOSSIERS_CRITERIA
      );
      resolve(res.data);
    } catch (err) {
      reject(errorsTransformer(err));
    }
  });
};
